import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Footer } from './Footer';  // ← ADDED
import { Toaster } from 'sonner';

const pageTitles = {
  '/dashboard': 'Beranda',
  '/certificates': 'Sertifikat SSL',
  '/logs': 'Log Aktivitas',
  '/settings': 'Pengaturan',
};

export function DashboardLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const currentTitle = pageTitles[location.pathname] || 'Dashboard';

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar - Desktop */}
      <aside className="hidden lg:block">
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
        />
      </aside>

      {/* Sidebar - Mobile */}
      {mobileMenuOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setMobileMenuOpen(false)}
          />
          <aside className="fixed inset-y-0 left-0 z-50 lg:hidden">
            <Sidebar 
              collapsed={false} 
              onToggle={() => setMobileMenuOpen(false)} 
            />
          </aside>
        </>
      )}

      {/* Main Content Area with Footer */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar */}
        <Topbar 
          onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          title={currentTitle}
        />
        
        {/* Main Content - Scrollable */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>

        {/* Footer - Always at bottom */}
        <Footer />  {/* ← ADDED */}
      </div>

      {/* Toast Notifications */}
      <Toaster 
        position="top-right" 
        richColors 
        closeButton
        toastOptions={{
          className: 'text-sm sm:text-base',
        }}
      />
    </div>
  );
}